import Vue from "vue";

import ImgPreview from "@/components/vendor/ImgPreview";

Vue.component("img-preview", ImgPreview);
